export class Constants {
  public static EMPTY_STRING = '';
  public static COMMA = ',';
  public static DOT = '.';
  public static XLSX_MIME_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
}
